import {EVENT_LAYOUT_READY} from "../../custom-events/DOMCustomEvents";
import DOMCustomEvents from "../../custom-events/DOMCustomEvents";
import {getDocumentOffsetPosition} from "../../../utils/dom";
import {getLayoutElement, getLayoutScrollObject} from "../../element/queries";

const verticalStickyComponents = {};
/**
 * @param id {string}
 * @param sticker {HTMLElement|Element}
 * @param getTopOffset {function}
 * @param getMutableBottomOffset {function}
 */
const setVerticalSticky = (id, sticker, getTopOffset, getMutableBottomOffset) => {
    if ('string' === typeof id
        && sticker instanceof HTMLElement
        && 'function' === typeof getTopOffset
        && 'function' === typeof getMutableBottomOffset
    ) {
        verticalStickyComponents[id] = [sticker, getTopOffset, getMutableBottomOffset];
    } else {
        console.error('setVerticalSticky invalid arguments', id);
    }
};
const unsetVerticalSticky = (id) => {
    delete verticalStickyComponents[id];
};
const handleVerticalSticky = (scrollTop, sticker, getTopOffset, getMutableBottomOffset) => {
    let topOffset = getTopOffset();
    if (topOffset === null) {
        return;
    }

    const mutableBottomOffset = getMutableBottomOffset();
    if (mutableBottomOffset !== null) {
        const minOf_TopOffset = mutableBottomOffset - sticker.offsetHeight;
        if (topOffset > minOf_TopOffset) {
            topOffset = minOf_TopOffset;
        }
    }

    const stickerDOP = getDocumentOffsetPosition(sticker);
    let deltaY = Math.ceil(scrollTop + topOffset - stickerDOP.top);
    if (deltaY < 0) {
        deltaY = 0;
    }

    sticker.style.transform = `translateY(${deltaY}px)`;

    const flagClass = 'vertical-sticky-fixed';
    if (deltaY > 0) {
        sticker.classList.add(flagClass);
    } else {
        sticker.classList.remove(flagClass);
    }
};
const init = () => {
    const layoutScrollObject = getLayoutScrollObject();

    const getScrollTop = () => {
        if (!isNaN(layoutScrollObject.scrollTop)) {
            return layoutScrollObject.scrollTop;
        }
        if (!isNaN(layoutScrollObject.scrollY)) {
            return layoutScrollObject.scrollY;
        }
        return 0;
    };

    layoutScrollObject.addEventListener('scroll', () => {
        for (let id in verticalStickyComponents) {
            if (verticalStickyComponents.hasOwnProperty(id)) {
                handleVerticalSticky(getScrollTop(), ...verticalStickyComponents[id]);
            }
        }
    }, {
        capture: true,
        passive: true
    });
};

if (getLayoutElement()) {
    init();
} else {
    DOMCustomEvents.observe(EVENT_LAYOUT_READY, 'utils.dom.setVerticalSticky', () => init());
}


export {
    setVerticalSticky,
    unsetVerticalSticky
}
